import { useEffect, useState } from 'preact/hooks';
import { get } from '../api.js';
import { Link } from '../router.js';
import { PaidToggle } from '../ui/Tag.jsx';
import { fmtRange } from '../../lib/dates.js';

export function Bookings() {
  const [bookings, setBookings] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    get('/bookings').then((r) => setBookings(r.bookings), (e) => setError(e.message));
  }, []);

  const paidChanged = ({ id, paid }) => setBookings((list) => list.map((b) => (b.id === id ? { ...b, paid } : b)));

  return (
    <>
      <div class="page-head">
        <h1>Rezervacije</h1>
        <Link href="/rezervacije/nova" class="btn">Nova rezervacija</Link>
      </div>
      {error && <p class="alert" role="alert">{error}</p>}
      {bookings && bookings.length === 0 && <p class="empty">Još nema rezervacija. Upiši prvu: Nova rezervacija.</p>}
      {bookings && bookings.length > 0 && (
        <table class="stack">
          <thead>
            <tr><th>Ko</th><th>Tura</th><th>Datum</th><th class="num">Ljudi</th><th>Plaćeno</th></tr>
          </thead>
          <tbody>
            {bookings.map((b) => (
              <tr key={b.id}>
                <td data-label="Ko"><Link href={`/rezervacije/${b.id}`}>{b.name}</Link></td>
                <td data-label="Tura"><Link href={`/ture/${b.departure.id}`}>{b.departure.tour.name}</Link></td>
                <td data-label="Datum">{fmtRange(b.departure.start_date, b.departure.end_date)}</td>
                <td data-label="Ljudi" class="num">{b.people}</td>
                <td data-label="Plaćeno"><PaidToggle booking={b} onChange={paidChanged} onError={setError} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
